module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.welcomeDismissed) ? _c('div', {
    staticClass: "absolute pin-t pin-r pin-b pin-l z-40 bg-black30 md:hidden",
    on: {
      "click": _vm.dismissWelcome
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "pop"
    }
  }, [(!_vm.welcomeDismissed) ? _c('WelcomeModule', {
    staticClass: "absolute pin-t pin-l pin-b pin-r z-50 flex items-center justify-around pointer-events-none md:hidden",
    on: {
      "add": _vm.addYourself,
      "close": _vm.dismissWelcome,
      "showRandom": _vm.showRandom
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('WelcomeModule', {
    staticClass: "absolute pin-t pin-l w-2/5 max-w-sm z-50 ml-4 mt-4 hidden md:block",
    on: {
      "add": _vm.addYourself,
      "close": _vm.dismissWelcome,
      "showRandom": _vm.showRandom
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18725f9c","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/views/WelcomeView.vue
// module id = 167
// module chunks = 0